import {gql, useMutation} from "@apollo/client";

const REMOVE_STAGE_MUTATION = gql`
mutation DeleteStage($stageId: Int!) {
  deleteStage(stageId: $stageId) {
    success    
  }
}

`;

export default function RemoveStageMutation() {
    return useMutation(REMOVE_STAGE_MUTATION);
}